<template>
    <button
        type="button"
        class="SiteButton"
        :class="[sizeClass, variantClass, { 'is-disabled': disabled }]"
        @click="$emit('onClick')"
    >
        <span><slot></slot></span>
    </button>
</template>

<script>
export default {
    name: 'SiteButton',
    props: {
        content: {
            default: '',
        },
        size: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: 'default',
        },
    },
    computed: {
        sizeClass() {
            return this.size === 'small' ? 'is-small' : '';
        },
        variantClass() {
            return this.variant ? `is-${this.variant}` : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.SiteButton {
    position: relative;
    border-radius: 4px;
    padding: 12px 32px;
    display: inline-block;
    background: linear-gradient(135deg, #ffe89e 0%, #ffcc80 100%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 0.5px solid #ffcc80;
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transform: translateZ(0);
    cursor: pointer;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, #ffe89e, transparent);
        transition: left 0.6s ease;
    }

    &:hover::before {
        left: 100%;
    }

    &:hover {
        background: linear-gradient(135deg, #ffe89e 0%, #ffcc80 100%);
        border: 0.5px solid #b8860b;
        transform: translateY(-2px);

        span {
            color: #1a1a1a;
            text-shadow: 0 1px 2px rgba(230, 184, 0, 0.4);
        }
    }

    &:focus-visible {
        outline: 3px solid #e6b800;
        outline-offset: 2px;
    }

    span {
        color: #1a1a1a;
        text-transform: uppercase;
        font-size: 1rem;
        letter-spacing: -0.01em;
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transform: translateZ(0);
        position: relative;
        z-index: 1;
    }

    &.is-small {
        padding: 8px 16px;

        span {
            font-size: 0.9rem;
        }
    }

    &.is-outline {
        background: transparent;
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border: 0.5px solid #ffcc80;

        &::before {
            display: none;
        }

        span {
            color: #ffcc80;
        }

        &:hover {
            background: rgba(230, 184, 0, 0.15);
            border: 0.5px solid #b8860b;
            transform: translateY(-2px);

            span {
                color: #e6b800;
            }
        }

        &:focus-visible {
            outline: 3px solid #e6b800;
            outline-offset: 2px;
        }
    }

    &.is-success {
        background: linear-gradient(135deg, rgb(95, 235, 186), #09d490);
        border: none;
        box-shadow: 0 10px 25px rgba(52, 47, 84, 0.25);

        &::before {
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 35px rgba(52, 47, 84, 0.35);
            background: linear-gradient(135deg, rgb(95, 235, 186), #09d490);
        }

        &:focus-visible {
            outline: 3px solid rgb(95, 235, 186);
            outline-offset: 2px;
        }

        span {
            color: #161936;
        }

        &:hover span {
            color: #161936;
        }
    }

    &:active {
        transform: translateY(0);
        transition: transform 0.1s ease;
    }

    &.is-disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;

        &:hover {
            transform: none;
            background: linear-gradient(135deg, #ffe89e 0%, #ffcc80 100%);
            border: 0.5px solid #ffcc80;
        }
    }
}
</style>
